// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6f908a5e","977":"4c89fabf"}[chunkId] + ".chunk.js";
};